import RichTextEditor from "react-rte";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { Color } from "../../../assets/color";
import RouteHeader from "../../../components/common/RouteHeader";
import DatatableHeading from "../../../components/heading/DatatableHeading";
import * as SuperadminActions from "../../../redux/actions/superadminAction";

const PrivacyPolicy = () => {
    const dispatch = useDispatch();
    const { privacyPolicyData } = useSelector(state => state?.superadminReducer);

    const [user_type, setUser_type] = useState("Platform");
    const [description, setDescription] = useState(RichTextEditor.createEmptyValue());
    const [inputFieldError, setInputFieldError] = useState({ description: "" });

    const handleInputFieldDetailError = (input, value) => setInputFieldError(p => ({ ...p, [input]: value }));

    const handleValidation = () => {
        let isValid = true;
        if (description?.toString("html") === "<p><br></p>") {
            handleInputFieldDetailError("description", "Please Enter Description");
            isValid = false;
        }
        return isValid;
    };

    const handleSubmit = e => {
        e.preventDefault();
        const payload = { type: "Privacy-Policy", user_type, description: description?.toString("html") };
        handleValidation() && dispatch(SuperadminActions.createUpdateStaticPage(payload));
    };

    useEffect(() => {
        dispatch(SuperadminActions.getPrivacyPolicy({ user_type }));
    }, [user_type]);

    useEffect(() => {
        setDescription(RichTextEditor.createValueFromString(String(privacyPolicyData || ""), "html"));
    }, [privacyPolicyData]);

    return (
        <>
            <RouteHeader title="Privacy Policy" sub_title="Manage Privacy Policy content displayed across the platform" />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <DatatableHeading title="Privacy Policy Content" sub_title="Update platform privacy practices" />

                <Grid container spacing={3} sx={{ marginTop: "20px" }}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <RichTextEditor
                            value={description}
                            onChange={setDescription}
                            editorStyle={{ minHeight: "45vh", borderRadius: "6px" }}
                            onFocus={() => handleInputFieldDetailError("description", null)}
                        />
                        {inputFieldError?.description && <div style={{ color: "#D32F2F", fontSize: "13px", marginTop: "6px" }}>{inputFieldError.description}</div>}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container justifyContent="flex-start">
                            <div onClick={handleSubmit} style={{ padding: "10px 24px", borderRadius: "6px", background: "linear-gradient(to right, #6653E8, #9544EB)", color: Color.white, fontSize: "14px", fontWeight: "500", cursor: "pointer" }}>
                                Save Changes
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default PrivacyPolicy;